<script lang="ts">
  import Modal from 'src/components/cabinet/#common/modal/Modal.svelte'
  import cornerTopLeft from 'src/components/main/#assets/top-left-border.svg'
  import cornerTopRight from 'src/components/main/#assets/top-right-border.svg'
  import cornerBottomLeft from 'src/components/main/#assets/bottom-left-border.svg'
  import cornerBottomRight from 'src/components/main/#assets/bottom-right-border.svg'
  import button from 'src/components/main/#assets/button.svg'
  import input from './input.svg'
  import nft from './nft.svg'
  import {userSubscribe} from 'src/components/cabinet/#services/subscribes'

  let email = ''
  let congratsModalOpen = false

  function subscribeHandler() {
    if (email !== '') {
      try {
        userSubscribe.send({data: {email}})
        email = ''
        congratsModalOpen = true
      } catch (err) {
        if (err.msg) {
          console.log(err.msg)
        } else {
          console.log('An Error Occurred, Please Try Again Later')
        }
      } finally {
        congratsModalOpen = true
      }
    }
  }
</script>

<section class="mint-coming" id="mint-coming">
    <div class="container">
        <div class="title">
            Mint Coming
            <div class="corner top-left" style="--cornerTopLeft: url({cornerTopLeft});"></div>
            <div class="corner top-right" style="--cornerTopRight: url({cornerTopRight});"></div>
            <div class="corner bottom-left" style="--cornerBottomLeft: url({cornerBottomLeft});"></div>
            <div class="corner bottom-right" style="--cornerBottomRight: url({cornerBottomRight});"></div>
        </div>
        <div class="row">
            <div class="col-lg-6">
                <div class="nft-wrapper">
                    <img src="{nft}" class="nft" alt="">
                </div>
            </div>
            <div class="col-lg-6">
                <div class="form">
                    <div>
                        <div class="label">E-mail</div>
                        <input type="email" class="field" bind:value={email} placeholder="Enter your e-mail" style="
                            --input: url({input});
                        ">
                        <button class="button" style="--button: url({button});" on:click={subscribeHandler}>
                            Waitlist me
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <Modal bind:visible={congratsModalOpen}>
            <svelte:fragment slot="content">
                {#if $userSubscribe.loading}
                    <div class="modal-custom__title text-center">Loading...</div>
                    <div class="modal-custom__text text-center">Loading...</div>
                {:else if $userSubscribe.hasValue && $userSubscribe.value}
                    <div class="modal-custom__title text-center">Congrats!</div>
                    <div class="modal-custom__text text-center">You’re qualified for the<br>Meowgon Mint</div>
                {:else if $userSubscribe.error}
                    <div class="modal-custom__title text-center">Error :(</div>
                    <div class="modal-custom__text text-center">{$userSubscribe.error.response.result.response?.value?.msg}</div>
                {/if}
            </svelte:fragment>
        </Modal>
    </div>
</section>

<style>
    .mint-coming {
        margin-bottom: 290px;
    }

    .title {
        font-size: 100px;
        font-weight: 700;
        padding: 18px 18px 0;
        background: linear-gradient(84deg, #FFF0E2 47%, #FFB287 71%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        line-height: normal;
        text-transform: uppercase;
        display: table;
        margin: 0 auto 100px;
        position: relative;
        z-index: 2;
    }

    .corner {
        width: 15px;
        height: 15px;
        position: absolute;
        transition: .3s;
    }

    .corner.top-left {
        top: 0;
        left: 0;
        background: var(--cornerTopLeft) no-repeat top left;
    }

    .corner.top-right {
        top: 0;
        right: 0;
        background: var(--cornerTopRight) no-repeat top right;
    }

    .corner.bottom-left {
        bottom: 0;
        left: 0;
        background: var(--cornerBottomLeft) no-repeat bottom left;
    }

    .corner.bottom-right {
        bottom: 0;
        right: 0;
        background: var(--cornerBottomRight) no-repeat bottom right;
    }

    .nft-wrapper {
        position: relative;
    }

    .nft-wrapper:before {
        content: "";
        width: 800px;
        height: 700px;
        left: 0;
        top: 200px;
        position: absolute;
        border-radius: 808px;
        background: rgba(255, 153, 0, 0.3);
        filter: blur(300px);
    }

    .nft {
        margin: 0 auto;
        display: block;
        width: 699px;
        height: auto;
        position: relative;
        z-index: 2;
    }

    .form {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        padding-right: 50px;
        position: relative;
    }

    .form:before {
        content: "";
        right: 0;
        top: 200px;
        width: 800px;
        height: 700px;
        position: absolute;
        border-radius: 808px;
        background: rgba(255, 153, 0, 0.3);
        filter: blur(300px);
    }

    .form > div {
        position: relative;
        z-index: 2;
    }

    .label {
        margin: 0 0 10px 38px;
        color: #B0A59D;
        font-size: 24px;
        font-style: italic;
        font-weight: 300;
        line-height: 100%;
    }

    .field {
        width: 553px;
        height: 90px;
        background: var(--input) no-repeat center;
        background-size: contain;
        border: 0;
        padding: 15px 55px;
        box-shadow: none;
        outline: none;
        font-size: 20px;
        color: white;
        line-height: 100%;
        margin-bottom: 50px;
    }

    .button {
        font-size: 40px;
        font-weight: 600;
        text-decoration: none;
        color: white;
        background: var(--button) no-repeat center;
        background-size: contain;
        padding: 38px 75px 32px;
        text-transform: uppercase;
        line-height: 100%;
        display: table;
        border: 0;
        user-select: none;
        margin: 0 auto;
        transition: .25s;
    }

    .button:hover {
        transform: scale(1.05);
    }

    @media(max-width: 1750px) {
        .nft {
            width: 600px;
        }

        .button {
            font-size: 34px;
        }
    }

    @media(max-width: 1520px) {
        .nft {
            width: 550px;
        }
    }

    @media(max-width: 1400px) {
        .mint-coming {
            margin-bottom: 200px;
            margin-top: -60px;
        }

        .title {
            font-size: 70px;
            margin: 0 auto 80px;
        }

        .nft {
            width: 470px;
        }

        .button {
            font-size: 30px;
        }

        .nft-wrapper:before,
        .form:before {
            width: 500px;
            height: 360px;
            top: 100px;
            border-radius: 50%;
            filter: blur(200px);
        }
    }

    @media(max-width: 1200px) {
        .nft {
            width: 400px;
        }

        .label {
            margin: 0 0 10px 30px;
            font-size: 20px;
        }

        .field {
            width: 400px;
            height: 70px;
            padding: 15px 40px;
            font-size: 18px;
            margin-bottom: 30px;
        }

        .button {
            font-size: 26px;
            padding: 28px 50px 24px;
        }

        .title {
            font-size: 60px;
        }
    }

    @media(max-width: 991px) {
        .title {
            font-size: 40px;
            width: 100%;
            text-align: center;
            padding: 5px 10px 0;
            margin-bottom: 50px;
        }

        .mint-coming {
            margin-top: 0;
        }

        .nft-wrapper {
            margin-bottom: 30px;
        }

        .field {
            width: 360px;
            height: 60px;
            padding: 15px 30px;
            font-size: 14px;
            margin-bottom: 20px;
        }

        .label {
            margin: 0 0 5px 25px;
            font-size: 16px;
        }

        .mint-coming {
            margin-bottom: 130px;
        }

        .form {
            z-index: 4;
            padding: 0;
        }

        .button {
            font-size: 20px;
            padding: 20px 36px 16px;
        }

        .nft {
            width: 300px;
        }

        .field {
            width: 330px;
            height: 56px;
        }
    }

    @media(max-width: 767px) {
        .nft {
            width: 100%;
        }

        .mint-coming {
            margin-top: 20px;
            margin-bottom: 120px;
        }

        .nft-wrapper:before,
        .form:before {
            width: 100%;
            height: 100%;
        }

        .button {
            font-size: 26px;
            padding: 28px 52px 24px;
            margin: 0 auto;
        }
    }
</style>
